import { useTranslation } from 'react-i18next'

import {
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_DELETE,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SAVE_TO_PROFILE,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_ADDITIONAL_EMAIL,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_EMAIL,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_EPOST,
  DocFlowSendingFieldName,
  updateSendingItem,
} from '../../DocFlowSending'
import { useDocFlowContext } from '../useDocFlowContext'
import { useDocFlowSendingContext } from '../useDocFlowSendingContext'
import { useSendingTableMassActions } from '../useSendingTableMassActions'

import {
  isChangedSaveToProfileValue,
  isChangedSendAdditionalEmailValue,
  isChangedSendEmailValue,
  isChangedSendEpostValue,
} from './useSendingTableActions.utils'

export function useSendingTableActions({ selectionData, usersTableData }) {
  const { documentId } = useDocFlowContext()

  const { setPageLoader } = useDocFlowSendingContext()

  const { t } = useTranslation()

  const {
    handleDelete,
    handleErrorAction,
    handleSuccessAction,
    setMassAction,
  } = useSendingTableMassActions({
    selectionData,
    usersTableData,
  })

  function setItemAction(action, item) {
    switch (action) {
      case DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_DELETE:
        handleDelete({ action, item })
        break

      default:
        break
    }
  }

  function handleUpdateSendingItem({ action, data, item }) {
    setPageLoader(true)

    updateSendingItem({ data, documentId, itemId: item.id })
      .then(res => {
        handleSuccessAction({ action })

        return res.data
      })
      .catch(() => {
        handleErrorAction(
          t('Notification.DocumentStaplingSendingTableActionErrorKey')
        )
      })
      .finally(() => {
        setPageLoader(false)
      })
  }

  function handleToggleSendEmail({ item, value }) {
    if (isChangedSendEmailValue({ item, value })) {
      handleUpdateSendingItem({
        action: DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_EMAIL,
        data: {
          [DocFlowSendingFieldName.SendEmail]: value,
        },
        item,
      })
    }
  }

  function handleToggleSendAdditionalEmail({ item, value }) {
    if (isChangedSendAdditionalEmailValue({ item, value })) {
      handleUpdateSendingItem({
        action:
          DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_ADDITIONAL_EMAIL,
        data: {
          [DocFlowSendingFieldName.SendAdditionalEmail]: value,
        },
        item,
      })
    }
  }

  function handleToggleSaveToProfile({ item, value }) {
    if (isChangedSaveToProfileValue({ item, value })) {
      handleUpdateSendingItem({
        action: DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SAVE_TO_PROFILE,
        data: {
          [DocFlowSendingFieldName.SaveToProfile]: value,
        },
        item,
      })
    }
  }

  function handleToggleSendEpost({ item, value }) {
    if (isChangedSendEpostValue({ item, value })) {
      handleUpdateSendingItem({
        action: DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_EPOST,
        data: {
          [DocFlowSendingFieldName.SendEpost]: value,
        },
        item,
      })
    }
  }

  return {
    handleToggleSaveToProfile,
    handleToggleSendAdditionalEmail,
    handleToggleSendEmail,
    handleToggleSendEpost,
    setItemAction,
    setMassAction,
  }
}
